import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowDown } from "lucide-react";
import { fmtNum } from "@/lib/studio";

const COLS = [["entries", "Entries"], ["stories", "Stories"], ["chapters", "Chapters"], ["words", "Words"], ["maps", "Maps"], ["timelines", "Timelines"], ["languages", "Languages"]];

export const UniverseTable = ({ universes }) => {
  const [sort, setSort] = useState("words");
  const rows = [...universes].sort((a, b) => (sort === "name" ? a.name.localeCompare(b.name) : b[sort] - a[sort]));
  const Head = ({ k, children, left }) => (
    <th className={`py-2 font-normal ${left ? "text-left" : "text-right"}`}>
      <button onClick={() => setSort(k)} className={`inline-flex items-center gap-1 transition-colors hover:text-[#F3EBDD] ${sort === k ? "text-[#FBBF24]" : ""}`} data-testid={`stats-sort-${k}`}>{children}{sort === k && <ArrowDown className="h-3 w-3" />}</button>
    </th>
  );
  return (
    <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5" data-testid="stats-universe-table">
      <div className="lf-label">Universe by universe</div>
      {!rows.length ? <p className="mt-3 text-sm text-[#A8A090]">You don't own any universes yet.</p> : (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full min-w-[560px] text-sm">
            <thead><tr className="text-xs text-[#A8A090]"><Head k="name" left>Universe</Head>{COLS.map(([k, l]) => <Head key={k} k={k}>{l}</Head>)}</tr></thead>
            <tbody>{rows.map((u) => (
              <tr key={u.id} className="border-t border-[#2D3442] text-[#F3EBDD] transition-colors hover:bg-[#13171F]" data-testid={`stats-universe-row-${u.id}`}>
                <td className="py-2 pr-3"><Link to={`/u/${u.id}`} className="hover:text-[#F59E0B]">{u.name}</Link></td>
                {COLS.map(([k]) => <td key={k} className="py-2 text-right tabular-nums" data-testid={`stats-universe-${u.id}-${k}`}>{fmtNum(u[k])}</td>)}
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </section>
  );
};
